















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component
export default class Box extends Vue {
  //Effect visuel with event Devices
  @Prop(String) private backgroundBox: String;

  //Properties Box
  @Prop(String) private name: String;
  @Prop(Boolean) private isActive?: Boolean;
  @Prop(String) private to?: string;
  @Prop(Object) private device?: Object;
  @Prop(String) private _id?: string;
  @Prop(Number) private index?: number;

  @Emit('deleteBox')
  public deleteBox() {
    let payload = {
      _id: this._id,
      device: this.device,
      index: this.index,
    };
    return payload;
  }
}
